<template>
  <el-dialog :title="title" width="600px" :before-close="handleCancel" :visible.sync="isVisible">
    <el-form
      label-position="right"
      label-width="150px"
      ref="matrixForm"
      :model="matrixForm"
      :rules="rules"
    >
      <el-form-item label="Question" prop="title">
        <el-input v-model="matrixForm.title"></el-input>
      </el-form-item>
      <el-form-item label="Choices">
        <draggable group="matrix-sub-choices" draggable=".draggable" v-model="choices">
          <div
            class="choice-item container-fluid draggable"
            v-for="(choice, index) in choices"
            :key="index"
          >
            <div class="row">
              <div class="col-xs-9">
                <strong>{{ index + 1 }}.</strong>
                {{ choice.title }}
              </div>
              <div class="col-xs-3">
                <span class="choice-tools pull-right">
                  <el-tooltip content="Remove">
                    <i class="fa fa-fw fa-trash" @click="handleRemoveChoice(index)"></i>
                  </el-tooltip>
                </span>
              </div>
            </div>
          </div>
        </draggable>
        <div>
          <el-input
            type="text"
            placeholder="Add new choice"
            v-model="choiceInput"
            @keydown.enter.native="handleAddChoice"
          ></el-input>
        </div>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">Cancel</el-button>
      <el-button
        type="primary"
        :loading="matrixChoicesCreating"
        :disabled="matrixChoicesCreating"
        @click="handleSave"
        >{{ matrixForm.id ? 'Save' : 'Create' }}</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import draggable from 'vuedraggable';
import { mapState } from 'vuex';

import HelpText from '@/components/common/HelpText';

import * as surveyBuilderTypes from '@/store/modules/surveybuilder/mutation-types';

export default {
  name: 'MatrixChoiceSaveDialog',
  components: {
    draggable,
    HelpText,
  },
  data: () => ({
    matrixForm: {},
    rules: {
      title: [
        { required: true, message: 'Please enter a question', trigger: 'blur' },
        { min: 3, message: 'Length should be a minimum of 3 characters', trigger: 'blur' },
      ],
    },

    choiceInput: '',
    choices: [],
  }),
  computed: {
    ...mapState('surveybuilder', [
      'matrixChoiceDialogForm',
      'matrixChoicesCreating',
      'matrixChoicesSaving',
    ]),

    title() {
      return this.matrixForm.id ? 'Edit music question' : 'Add new music question';
    },

    isVisible: {
      get() {
        return this.$store.state.surveybuilder.matrixChoiceDialogVisible;
      },
      set(value) {
        this.$store.commit(
          `surveybuilder/${surveyBuilderTypes.SET_MATRIX_CHOICE_DIALOG_VISIBILITY}`,
          value,
        );
      },
    },
  },
  mounted() {
    this.initForm();
  },
  methods: {
    initForm() {
      this.matrixForm = { ...this.matrixChoiceDialogForm };
      this.choices = this.matrixForm.title !== null ? this.matrixForm.choices : [];
    },

    resetForm() {
      this.initForm();
      this.$refs.matrixForm.resetFields();
      this.$store.commit(`surveybuilder/${surveyBuilderTypes.RESET_MATRIX_CHOICE_DIALOG_FORM}`);
      this.$store.commit(
        `surveybuilder/${surveyBuilderTypes.SET_MATRIX_CHOICE_DIALOG_VISIBILITY}`,
        false,
      );
    },

    handleCancel() {
      this.resetForm();
    },

    handleSave() {
      this.$refs.matrixForm.validate(valid => {
        if (valid) {
          if (this.matrixForm.id) {
            this.handleEdit();
          } else {
            this.handleCreate();
          }
        }
      });
    },

    handleEdit() {
      const theChoices = { ...this.matrixForm,
        choices: this.choices.map((d, i) => ({
          title: d.title,
          polarity: i,
          order: i,
        })) };
      this.$store.dispatch('surveybuilder/updateMatrixChoice', theChoices).then(() => {
        this.resetForm();
        this.isVisible = false;
      });
    },

    handleCreate() {
      const matrixChoice = { ...this.matrixForm,
        choices: this.choices.map((d, i) => ({
          title: d.title,
          polarity: i,
          order: i,
        })) };
      this.$store
        .dispatch('surveybuilder/createMatrixChoice', {
          matrixChoice,
        })
        .then(() => this.resetForm());
    },

    handleAddChoice() {
      this.choices.push({ title: this.choiceInput });
      this.choiceInput = '';
    },

    handleRemoveChoice(index) {
      this.choices.splice(index, 1);
    },
  },
  watch: {
    matrixChoiceDialogForm() {
      this.initForm();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../assets/style/_variables_live.scss';

.choice-item {
  width: 100%;
  margin-bottom: 4px;
  border-radius: 3px;
  background-color: $colony-light-gray;
  border-color: darken($colony-light-gray, 15%);
}

.choice-tools {
  cursor: pointer;
  color: darken($colony-light-gray, 15%);
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// MatrixChoiceSaveDialog.vue?5389dfe1